var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33173 24.7486C3.87666 25.1377 3.29735 25.3079 2.37097 25.3079H1.98657V20.6645H2.37097C3.29735 20.6645 3.85444 20.8232 4.33173 21.2317C4.82442 21.6538 5.12048 22.3049 5.12048 22.9784C5.12048 23.6552 4.82442 24.3295 4.33173 24.7486ZM2.65793 19.4751H0.554688V26.4978H2.6451C3.75756 26.4978 4.56056 26.2445 5.26439 25.6855C6.10045 25.0235 6.59655 24.0238 6.59655 22.9882C6.59655 20.9151 4.97802 19.4751 2.65793 19.4751Z",
    fill: "#201D1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25586 19.4751H8.68205V26.4978H7.25586V19.4751Z",
    fill: "#201D1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1852 22.1665C11.3244 21.8643 11.0728 21.6631 11.0728 21.2835C11.0728 20.8423 11.5224 20.5078 12.1408 20.5078C12.5693 20.5078 12.9224 20.6719 13.2985 21.073L14.0431 20.1383C13.4279 19.6202 12.6916 19.3579 11.8889 19.3579C10.5901 19.3579 9.60014 20.2226 9.60014 21.3659C9.60014 22.3366 10.0603 22.8291 11.4033 23.2967C11.9647 23.4835 12.2499 23.6111 12.3944 23.6975C12.6805 23.8745 12.823 24.1281 12.823 24.4212C12.823 24.9924 12.3499 25.4124 11.7105 25.4124C11.0297 25.4124 10.4789 25.0862 10.1492 24.4738L9.22656 25.3289C9.88623 26.2538 10.677 26.6672 11.7664 26.6672C13.2521 26.6672 14.299 25.7153 14.299 24.3596C14.299 23.2424 13.8135 22.7361 12.1852 22.1665",
    fill: "#201D1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.748 22.9882C14.748 25.0535 16.4421 26.6538 18.6228 26.6538C19.2378 26.6538 19.7649 26.5376 20.4141 26.2445V24.6306C19.8404 25.1822 19.3369 25.3998 18.6855 25.3998C17.2445 25.3998 16.2238 24.4021 16.2238 22.9784C16.2238 21.6333 17.2776 20.5677 18.6228 20.5677C19.3016 20.5677 19.8202 20.7978 20.4141 21.3576V19.7456C19.7869 19.4421 19.2722 19.3164 18.6522 19.3164C16.484 19.3164 14.748 20.9481 14.748 22.9882",
    fill: "#201D1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0097 24.1899L30.0526 19.4751H28.4922L31.6033 26.6751H32.3707L35.5422 19.4751H33.9941L32.0097 24.1899",
    fill: "#201D1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1914 26.4978H40.25V25.3079H37.6233V23.4122H40.1503V22.2226H37.6233V20.6645H40.25V19.4751H36.1914V26.4978",
    fill: "#201D1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0458 22.7044H42.6303V20.5803H43.0692C43.9633 20.5803 44.4424 20.9394 44.4424 21.6236C44.4424 22.3265 43.9633 22.7044 43.0458 22.7044ZM45.9161 21.5471C45.9161 20.232 44.9735 19.4751 43.3211 19.4751H41.1953V26.4978H42.6303V23.6743H42.8164L44.7937 26.4978H46.5544L44.2455 23.5379C45.3246 23.3269 45.9161 22.6218 45.9161 21.5471Z",
    fill: "#201D1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6942 23.0045C28.6942 25.0263 26.9822 26.6651 24.8685 26.6651C22.7553 26.6651 21.043 25.0263 21.043 23.0045C21.043 20.9823 22.7553 19.3433 24.8685 19.3433C26.9822 19.3433 28.6942 20.9823 28.6942 23.0045",
    fill: "url(#paint0_linear_458_17930)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6942 23.0045C28.6942 25.0263 26.9822 26.6651 24.8685 26.6651C22.7553 26.6651 21.043 25.0263 21.043 23.0045C21.043 20.9823 22.7553 19.3433 24.8685 19.3433C26.9822 19.3433 28.6942 20.9823 28.6942 23.0045",
    fill: "url(#paint1_radial_458_17930)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_17930",
    x1: 22.5214,
    y1: 20.0351,
    x2: 27.2831,
    y2: 25.7851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9D2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_458_17930",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7108 24.5273) rotate(-128.1) scale(5.02342 5.24944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9D2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#DF7624",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760188,
    stopColor: "#BF4B23",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.58c46f7a260398f5db160ed5fbef4ba3.svg";
export { ForwardRef as ReactComponent };